import request from '@/utils/request'

// 莆田信用卡用户国庆抽奖-登录
export const login = (data) => {
  return request({
    url: `mixApi/psbcNationalDayLottery/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: false,
  })
}
// 莆田信用卡用户国庆抽奖-获取登录用户信息
export const getUserInfo = (data) => {
  return request({
    url: `mixApi/psbcNationalDayLottery/getUserInfo`,
    method: 'post',
    data,
    token: sessionStorage.getItem('psbcNationalDayLotteryToken'),
  })
}
// 莆田信用卡用户国庆抽奖-登记用户信息
export const registerUserInfo = (data) => {
  return request({
    url: `mixApi/psbcNationalDayLottery/registerUserInfo`,
    method: 'post',
    data,
    token: sessionStorage.getItem('psbcNationalDayLotteryToken'),
  })
}
// 莆田信用卡用户国庆抽奖-抽奖
export const qqnbcl = (data) => {
  return request({
    url: `mixApi/psbcNationalDayLottery/qqnbcl`,
    method: 'post',
    data,
    token: sessionStorage.getItem('psbcNationalDayLotteryToken'),
    hideErrMsgToast: true
  })
}
// 莆田信用卡用户国庆抽奖-我的奖品
export const myPrize = (data) => {
  return request({
    url: `mixApi/psbcNationalDayLottery/myPrize`,
    method: 'post',
    data,
    token: sessionStorage.getItem('psbcNationalDayLotteryToken'),
  })
}